import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Navbar } from '@/components/Navbar'
import apiService from '@/api/service'

export const Waiting = (): JSX.Element => {
    const navigate = useNavigate()
    const [checkCount, setCheckCount] = useState(0)
    const [error, setError] = useState<string>('')

    useEffect(() => {
        // 檢查是否有 store_code
        const storeCode = apiService.getCurrentStoreCode()
        if (!storeCode) {
            console.error('未找到 store_code，跳轉到登入頁面')
            navigate('/login')
            return
        }

        let currentCheckCount = 0

        // 定義檢查函數
        const checkStoreFlag = async () => {
            try {
                currentCheckCount++
                console.log(`檢查店家資料處理狀態 (第 ${currentCheckCount} 次)...`)
                setCheckCount(currentCheckCount)

                const response = await apiService.checkStoreFlag({
                    store_code: storeCode
                })

                console.log('checkFlag 回應:', response)

                // 檢查 isRunComplete 是否為 "true"
                if (response.status === 'success' && response.isRunComplete === 'true') {
                    console.log('資料處理完成，跳轉到儀表板')
                    navigate('/dashboard')
                } else {
                    console.log('資料處理中，繼續等待...')
                }
            } catch (error) {
                console.error('檢查店家標記失敗:', error)
                setError('檢查狀態失敗，將繼續重試...')
            }
        }

        // 立即執行第一次檢查
        checkStoreFlag()

        // 每 10 秒執行一次檢查
        const intervalId = setInterval(checkStoreFlag, 10000)

        // 清除定時器
        return () => {
            console.log('清除檢查定時器')
            clearInterval(intervalId)
        }
    }, [navigate])

    return (
        <div className="bg-white w-full min-h-screen flex flex-col">
            {/* 使用主項目的 Navbar 組件 */}
            <Navbar />

            {/* Waiting 主要內容區域 - 响应式 */}
            <div className="w-full min-h-[600px] md:h-[976px] relative bg-[#aeceb7] flex items-center justify-center">
                <img
                    className="absolute w-full h-full top-0 left-0 object-cover"
                    alt="Bg pattern"
                    src="/img/bg-pattern.png"
                />

                <div className="relative flex flex-col items-center justify-center gap-8 px-4">
                    <img
                        className="w-[280px] md:w-[380px] lg:w-[476px] h-auto"
                        alt="Waiting image"
                        src="/img/watting-image.svg"
                    />

                    <div className="font-black text-2xl md:text-3xl lg:text-4xl tracking-[3.60px] md:tracking-[5.40px] lg:tracking-[7.20px] leading-9 [font-family:'Noto_Sans_TC',Helvetica] text-white text-center px-4">
                        請耐心等待資料更新...
                    </div>

                    {/* 檢查次數提示 - 响应式 */}
                    <div className="font-medium text-base md:text-lg tracking-[1.50px] md:tracking-[2.00px] [font-family:'Noto_Sans_TC',Helvetica] text-white text-center">
                        已檢查 {checkCount} 次
                    </div>

                    {/* 錯誤訊息 - 响应式 */}
                    {error && (
                        <div className="w-full max-w-[90%] md:max-w-[400px] font-medium text-xs md:text-sm tracking-[0.80px] md:tracking-[1.00px] [font-family:'Noto_Sans_TC',Helvetica] text-red-300 text-center px-4">
                            {error}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

